// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";
import { getServerToolsQueryOptions } from "@/app/servers/api/get-server-tools";
import { ServerDetails } from "@/app/servers/details/details";

const sectionSchema = z.enum(["tools", "logs"]);
const searchParamsSchema = z.object({
  section: sectionSchema.catch("tools").default("tools"),
});

const defaultValues = {
  section: "tools" as const,
} satisfies Partial<z.infer<typeof searchParamsSchema>>;

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId"
)({
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  component: () => (
    <Suspense
      fallback={
        <div className="flex flex-col gap-8 p-4">
          <Skeleton className="h-48 rounded-xl" />
          <Skeleton className="h-64 rounded-xl" />
        </div>
      }
    >
      <ServerDetails />
    </Suspense>
  ),
  loader: ({ params, context: { queryClient } }) => ({
    serverId: params.serverId,
    tools: queryClient.ensureQueryData(
      getServerToolsQueryOptions({
        id: params.serverId,
        scope: params,
      })
    ),
    crumb: `${params.serverId}`,
  }),
});
